import Tool, { type ToolArgs } from '../../../tools/Tool';
import { wrapLinkCard } from '../utils';
import { Editor } from 'slate';
import isUrl from 'is-url';
import mediaPlacement from '../../../assets/icons/mediaPlacement.svg';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';

// Insert a hyperlink card into the editor.
class ToolInsertLinkCard extends Tool {
  static toolName = 'Link card';
  static iconSvg = mediaPlacement;
  static shortcut = 'Cmd+Shift+k';
  static withoutRefocus = true; // So that when a link card is first created focus stays in the link editor.

  static action({ editor }: ToolArgs): void {
    if (!editor?.selection) return;

    const selectedText = Editor.string(editor, editor.selection);
    const textIsUrl = isUrl(selectedText);

    wrapLinkCard(editor, selectedText, textIsUrl);
  }

  static renderMenuIcon(toolArgs: ToolArgs): JSX.Element {
    return svgToIcon(mediaPlacement);
  }
}

export default ToolInsertLinkCard;
